// The client side of /api/today (BUILD-BRIEF §4, §6 — interactions agent).
//
// `TodayResponse` (src/shared/types.ts) is the contract every other page may rely on; this
// route answers a few extra fields beyond it (the `_detail` and `_by_kind` companions) so the
// rail's detail line can say something specific. `TodayView` documents them locally — they are
// additive, never a replacement for a documented field.
import { request } from './client.js';
import type { Action, Signal, TodayResponse } from '../../shared/types.js';

export interface TodayView extends TodayResponse {
  unheld_by_kind: Record<string, number>;
  ball_detail: string | null;
  stale_detail: string | null;
  cooling_detail: string | null;
  /** Round 2 (§10). `signals` itself stays `number | null` — null means no producer has run. */
  signals_detail: string | null;
  signals_line: Signal[];
  /** Null until something has been scored: not collected, which is not "no actions". */
  actions: Action[] | null;
}

export function getToday(): Promise<TodayView> {
  return request('/today');
}
